import React from 'react';
import ReactDOMServer from 'react-dom/server';
import PropTypes from 'prop-types';
const moment = require('moment-timezone');
import { Table, Column, Cell } from 'fixed-data-table-2';
import { AutoSizer } from 'react-virtualized';
const _ = {
    forEach: require('lodash/forEach'),
}
const Moment = require('moment');

const Globals = require('../../../../app/globals');
const Strings = require('../../../../app/shared/Strings');
const StringUtil = require('../../../../app/shared/StringUtil');
const SortUtil = require('../../util/SortUtil');
const TimeUtil = require('../../../../app/shared/TimeUtil');
import TableHeaderSortIcon from './TableHeaderSortIcon';
const ExportsUtil = require('../../util/ExportsUtil');

// for data with type 'icon'
/* TODO: is this ever used? necessary?
class IconCell extends React.Component {
  render() {
    // const {rowIndex, field, data, ...props} = this.props;
    const rowIndex = this.props.rowIndex;
    const field = this.props.field;
    const data = this.props.data;
    const iconClassNames = data[rowIndex][field];
    console.log("IconCell props: " + JSON.stringify(this.props));
    return (
      <Cell {...props}>
        <i className={iconClassNames}/>
      </Cell>
    );
  }
};
*/


// Use this general format for props.columns
// let columns = [
//         {
//             displayName: 'ID',
//             key:'id',
//             size: 1,
//             type: 'int'
//         },
//         {
//             displayName: 'Name',
//             key:'name',
//             size: 2,
//             type: 'string',
//             caseSensitive: true,
//         },
//         {
//             displayName: 'Activity ID',
//             key:'activity_id',
//             size: 1,
//             type: 'int'
//         },
//         {
//             displayName: 'Create Date',
//             key:'create_date',
//             size: 2,
//             type: 'date'
//         }
//     ];
//TODO: specifiy columns as part of props. add keys: searchable, sortable

/*
props.displayColumnCallbacksId format:
displayColumnCallbacksId = {
    someKey: function(uniqueRowKey) { return Math.round(dataFromParentContext[uniqueRowKey].someFloatingPoint); },
    etc...
}
*/

const propTypes = {
    classNameTableContainer: PropTypes.string,
    variant: PropTypes.oneOf(['default', 'new']),
    title: PropTypes.string,
    titleSize: PropTypes.oneOf(['sm', 'md', 'lg', 'xl']),
    rows: PropTypes.array,
    columns: PropTypes.array,
    uniqueRowKey: PropTypes.string,
    onRowClick: PropTypes.func,
    selectedRowKey: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    dateFormat: PropTypes.string,
    dateTimezone: PropTypes.string,
    dateFormatUTC: PropTypes.bool,
    displayColumnCallbacksId: PropTypes.object,
    displayColumnCallbacksRow: PropTypes.object,
    defaultSort: SortUtil.SortObjPropType.isRequired,
    width: PropTypes.number,
    totalName: PropTypes.string,
    additionalTotalRowKeys: PropTypes.array,
    tableHeight: PropTypes.number,
    hideFilter: PropTypes.bool,
    hideTotal: PropTypes.bool,
    formatTotals: PropTypes.bool,
    onRefresh: PropTypes.func,
    refreshDisabled: PropTypes.bool,
    rowHeight: PropTypes.number,
};

const defaultProps = {
    classNameTableContainer: '',
    variant: 'default',
    rows: [],
    columns: [],
    title: "",
    titleSize: "lg",
    uniqueRowKey: "id",
    selectedRowKey: null,
    dateFormat: null,
    dateTimezone: '',
    dateFormatUTC: false,
    displayColumnCallbacksId: {},
    displayColumnCallbacksRow: {},
    defaultSort: {
        key: 'id',
        type: Globals.sort.type.INT,
        asc: true
    },
    tableHeight: undefined, // varible height for fixed-data-table-2
    // containerWidth: 1000,
    containerWidth: undefined,
    totalName: "Total",
    additionalTotalRowKeys: [],
    hideFilter: false,
    hideTotal: false,
    rowHeight: 50,
};

class SortableTableClassic extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            sort: props.defaultSort,
            filter: '',
        };

        this.rowClassNameGetter = this.rowClassNameGetter.bind(this);
        this.onFilterChange = this.onFilterChange.bind(this);
        this.sort = this.sort.bind(this);
        this._filterRows = this._filterRows.bind(this);
        this.onRowClick = this.onRowClick.bind(this);
    }

    cellDataGetter(rows, rowIndex, columnKey) {
        if (this.props.displayColumnCallbacksId[columnKey]) {
            return this.props.displayColumnCallbacksId[columnKey](rows[rowIndex][this.props.uniqueRowKey]);
        }

        if (this.props.displayColumnCallbacksRow[columnKey]) {
            return this.props.displayColumnCallbacksRow[columnKey](rows[rowIndex]);
        }

        const columnData = rows[rowIndex][columnKey];
        const columnProp = this.props.columns.find(col => col.key === columnKey)
        if (this.props.dateFormat && columnProp.type === 'date') {
            let dateFormatted;
            let date = columnData || 0;
            if (this.props.dateTimezone) {
                dateFormatted = TimeUtil.convertToTimeZone(date, this.props.dateTimezone).format(this.props.dateFormat)
            }
            else if (!this.props.dateFormatUTC) {
                dateFormatted = moment.tz(date, moment.tz.guess()).format(this.props.dateFormat);
            }
            else {
                dateFormatted = moment(date).utc().format(this.props.dateFormat);
            }

            return dateFormatted;
        }

        if (columnProp.type === 'bool') {
            return StringUtil.formatBool(columnData, true);
        }

        if (columnProp.type === 'usd') {
            return StringUtil.formatUSD(columnData);
        }

        return columnData;
    }

    rowClassNameGetter(rows, rowIndex) {
        if (!!this.props.selectedRowKey && rows[rowIndex][this.props.uniqueRowKey] === this.props.selectedRowKey) {
            return 'user-row-highlighted';
        }

        return '';
    }

    onFilterChange(e) {
        this.setState({ filter: e.target.value });
    }

    sort(column, e) {
        e.preventDefault();
        const newSortKey = column.sortKey || column.key; // use sortKey if specified, otherwise use key
        const newSortObj = SortUtil.updateSortObj(this.state.sort, newSortKey, column.type);
        this.setState({ sort: newSortObj });
        if (this.props.onSortChange) {
            this.props.onSortChange(newSortKey,newSortObj.asc);
        }
    }

    _filterRows() {
        const _rows = this.props.rows;

        if (!this.state.filter) {
          return _rows;
        }

        const filterBy = this.state.filter;
        const filterByToLower = this.state.filter.toLowerCase();
        const size = _rows.length; //the benefit of precalculating this is debateable, todo: test
        const columnKeysSize = this.props.columns.length;

        let filteredRows = [];
        for (let rowIndex = 0; rowIndex < size; rowIndex++) {

            let matched = false;
            for(let columnIndex = 0; columnIndex < columnKeysSize; columnIndex++) {
                if(matched) continue; //optimization

                const columnKey = this.props.columns[columnIndex].key;
                if(!_rows[rowIndex][columnKey]) continue; //ignore falsy columns

                const columnCaseSensitive = this.props.columns[columnIndex].caseSensitive || false;

                if (!columnCaseSensitive && _rows[rowIndex][columnKey].toString().toLowerCase().indexOf(filterByToLower) !== -1) {
                    filteredRows.push(_rows[rowIndex]);
                    matched = true;
                }
                else if (columnCaseSensitive && _rows[rowIndex][columnKey].toString().indexOf(filterBy) !== -1) {
                    filteredRows.push(_rows[rowIndex]);
                    matched = true;
                }
            }
        }

        return filteredRows;
    }

    onRowClick(rows, e, rowIndex) {
        if (!!this.props.onRowClick) {
            this.props.onRowClick(e, rows[rowIndex][this.props.uniqueRowKey]);
        }
    }

    /**
        function(
          cellData: any,
          cellDataKey: string,
          rowData: object,
          rowIndex: number,
          columnData: any,
          width: number
        )
    **/
    
    exportTableAsCsv=(rows,e)=>{
        let arr = [];
        let row = [];
        _.forEach(this.props.columns,(column,k)=>{
            if (column.type === 'iconButton') {
                return; // skip
            }
            row.push(column.displayName);
        })
        arr.push(row);
        const dummyDoc = document.implementation.createHTMLDocument('dummy'); // stops browser from preload images in the temporary div 
        _.forEach(rows,(r,rowIndex)=>{
            row = [];
            _.forEach(this.props.columns,(column,k)=>{
                if (column.type === 'iconButton') {
                    return; // skip
                }
                let cell = this.cellDataGetter(rows, rowIndex, column.key);
                let cell_text;
                if (typeof cell === 'object') {
                    const html = ReactDOMServer.renderToString(cell);
                    const elem = $(html,dummyDoc);
                    cell_text = elem.text();
                }
                else {
                    cell_text = cell.toString();
                }
                row.push(cell_text);
            })
            arr.push(row);
        });
        // ${Moment(new Date()).format('YYYY-MM')}
        ExportsUtil.exportArrAsCsv(
            arr,
            this.props.title || 'table',
            Strings['en'].export.DOWNLOAD_CSV_FILE
        );
    }
    
    // renderIconButton(cellData, cellDataKey, rowData, rowIndex, columnData, width) {
    renderIconButton(rows, rowIndex, columnKey) {
        const iconButtonData = rows[rowIndex][columnKey];
        return (
            <span
            className={iconButtonData.className}
            role="button"
            onClick={
                function(e) {
                    e.stopPropagation();
                    console.log("calling cellData.onClick");
                    iconButtonData.onClick();
                }
            }
            />
        );
    }

    render() {
        const self = this;
        let rows = this._filterRows();
        rows = SortUtil.sortObjectArray(rows, this.state.sort);
        let tableClassName = "";
        if (!this.props.variant || this.props.variant === "default") {
            tableClassName = "";
        }
        else if (this.props.variant === "new") {
            tableClassName = "sortableTableClassic--new";
        }

        let titleClassName = "";
        if (!this.props.titleSize || this.props.titleSize === "lg") {
            titleClassName = "view-title";
        }
        else if (this.props.titleSize === "sm") {
            titleClassName = "heading-sm";
        }
        else if (this.props.titleSize === "md") {
            titleClassName = "heading-md";
        }
        else if (this.props.titleSize === "xl") {
            titleClassName = "heading-xl";
        }

        function renderHeaderCol(column) {
            const sortKey = column.sortKey || column.key;
            const isSortCol = SortUtil.sortObjUsesKey(self.state.sort, sortKey);
            const sortIconElem =  isSortCol ? <TableHeaderSortIcon className="margin-left-sm" asc={SortUtil.sortObjIsAsc(self.state.sort)} /> : null;
            return (
                <Cell>
                    <a
                        className={isSortCol ? "header-link link-selected" : "header-link"}
                        href="#"
                        onClick={self.sort.bind(self, column)}
                    >
                        {column.displayName}
                        {sortIconElem}
                    </a>
                </Cell>
            );
        }
        
        let additionalTotals = [];
        _.forEach(this.props.additionalTotalRowKeys,(rk,index)=>{
            if (this.props.hideTotal) return; // hide ALL totals
            var columnProp = this.props.columns.find(col => col.key === rk);
            if (columnProp) {
                var t = 0;
                _.forEach(rows,function(r) {
                    t += Number(r[rk] || 0);
                })
                if (this.props.formatTotals) {
                    t = Number(t).toLocaleString(); // commas (english)
                }
                additionalTotals.push(
                    <span key={'t'+index} className="fr table-total-spacing">{" Total " + columnProp.displayName + ": " + t + " "}</span>
                );
            }
        });

        return (
            <div className={`table-container width-100p ${this.props.classNameTableContainer}`}>
                {(!!this.props.title) &&
                    <h2 className={titleClassName}>{this.props.title}</h2>
                }
                <div className="margin-bottom-md">
                    {(!this.props.hideFilter) &&
                        <input
                            className="search"
                            style={{marginLeft:'5px', marginRight:'5px'}}
                            onChange={this.onFilterChange}
                            placeholder="Search"
                        />
                    }
                    { this.props.onRefresh ?
                    <button title="refresh" className="bare-text-button glyph button-following" disabled={this.props.refreshDisabled} onClick={this.props.onRefresh}>
                        <span className="sr-only">refresh</span>
                        <i className="fa fa-refresh" aria-hidden="true"/>
                    </button>
                    : null }
                    {additionalTotals}
                    {!this.props.hideTotal ? <span className="fr">{this.props.totalName}: {rows.length}</span> : null}
                    { this.props.exportButtonName ? 
                    <button className="table-export-button" onClick={(e)=>{this.exportTableAsCsv(rows,e)}}>{this.props.exportButtonName}</button> 
                    : null }
                    <div className="float-clear"/>
                </div>

                <AutoSizer disableHeight nonce={GlobalConfig.CspNonce}>
                    {({ width }) => (
                        <Table
                            className={tableClassName}
                            rowHeight={this.props.rowHeight}
                            rowClassNameGetter = {this.rowClassNameGetter.bind(this, rows)}
                            rowsCount={rows.length}
                            width={width}
                            height={this.props.tableHeight}
                            maxHeight={500}
                            headerHeight={50}
                            onRowClick={this.onRowClick.bind(this, rows)}
                        >
                            {   this.props.columns.map(column => {
                                    if (column.type === 'iconButton') {
                                        return (
                                            <Column
                                                key={column.key}
                                                label={column.displayName}
                                                width={1}
                                                flexGrow={column.size}
                                                dataKey={column.key}
                                                cell={({ rowIndex, ...props }) => (
                                                        <Cell {...props}>
                                                            {this.renderIconButton(rows, rowIndex, column.key)}
                                                        </Cell>
                                                    )}
                                            />
                                        );
                                    }

                                    return (
                                        <Column
                                            key={column.key}
                                            header={renderHeaderCol.bind(self, column)}
                                            width={1}
                                            flexGrow={column.size}
                                            dataKey={column.key}
                                            cell={({ rowIndex, ...props }) => (
                                                    <Cell {...props}>
                                                        { self.cellDataGetter(rows, rowIndex, column.key) }
                                                    </Cell>
                                                )}
                                            />
                                    );
                                })
                            }
                    </Table>
                )}
            </AutoSizer>
            </div>
        );
    }
}

SortableTableClassic.propTypes = propTypes;
SortableTableClassic.defaultProps = defaultProps;

export default SortableTableClassic;